export const FETCH_EVENTS = 'FETCH_EVENTS';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const FETCH_EVENTS_COUNT = 'FETCH_EVENTS_COUNT';
export const EDIT_EVENTS_SUCCESS = 'EDIT_EVENTS_SUCCESS';
export const ADD_EVENTS_SUCCESS = 'ADD_EVENTS_SUCCESS';
export const EVENTS_STATUS = 'EVENTS_STATUS';
